import { Consent } from '../../../entities/Consent';
import { setGivenConsents } from '../../../frameworks_drivers/redux/reducers/onboardingInformation/onboardingInformationSlice';
import store from '../../../store';
import {
  waitForDataProtection,
  waitForReturnPolicy,
  waitForTermsOfService
} from '../../../frameworks_drivers/localization/Localization';

// TODO: Remove infrastructure code and domain code
export class SetCommonConsentsToOnboardingStoreUseCase {
  async execute(t: any, isOrder: boolean = false): Promise<void> {
    await Promise.all([waitForTermsOfService, waitForReturnPolicy, waitForDataProtection]);

    const signingTimestamp = new Date();

    const consents: Consent[] = [
      {
        type: 'terms_of_service',
        version: t('terms_of_service:content.footer.status'),
        dateSigned: signingTimestamp.toISOString().split('.')[0] + 'Z'
      },
      {
        type: 'return_policy',
        version: t('return_policy:content.footer.status'),
        dateSigned: signingTimestamp.toISOString().split('.')[0] + 'Z'
      },
      {
        type: 'data_protection',
        version: t('data_protection:content.footer.status'),
        dateSigned: signingTimestamp.toISOString().split('.')[0] + 'Z'
      }
    ];

    const state = store.getState();

    const existingConsents = state.onboardingInfo?.givenConsents ?? [];
    const updatedConsents = [...existingConsents, ...consents];
    store.dispatch(setGivenConsents(updatedConsents));
  }
}
